export default __webpack_public_path__ + "static/media/ronin.a667a10b.webp";